// Personalization fields for the workshop's products (snippets/kisisel.liquid).
// The field list comes from the product's kisisel.alanlar metafield. Fields with "adetSecenek" repeat as many times as
// the number in the selected value of that product option, so the rows follow the theme's own variant picker
// ("variant:change"). Values typed so far are kept when the rows are rebuilt. A hidden required input carries a custom
// validity: the theme's form runs checkValidity() before adding to cart, so an empty field stops the add and the
// customer is taken to it.
if (!window.customElements.get('kisisel-alanlar')) {
  // The store's birthstone list (same as the birthstone necklace page); colours sampled from the stone chart photo.
  const TASLAR = [
    { ay: 'January', tas: 'Garnet', renk: '#8a1624', parlak: '#d23b4c' },
    { ay: 'February', tas: 'Amethyst', renk: '#65529b', parlak: '#a791ca' },
    { ay: 'March', tas: 'Aquamarine', renk: '#99d1e4', parlak: '#c4ebf6' },
    { ay: 'April', tas: 'Diamond', renk: '#c9cacb', parlak: '#f8f8f6' },
    { ay: 'May', tas: 'Emerald', renk: '#418247', parlak: '#7db862' },
    { ay: 'June', tas: 'Alexandrite', renk: '#a098b9', parlak: '#cac7dd' },
    { ay: 'July', tas: 'Ruby', renk: '#d12267', parlak: '#dc508f' },
    { ay: 'August', tas: 'Peridot', renk: '#8f9f3e', parlak: '#cfda56' },
    { ay: 'September', tas: 'Sapphire', renk: '#2a3575', parlak: '#5669b0' },
    { ay: 'October', tas: 'Pink Tourmaline', renk: '#eaa7b9', parlak: '#f9cedc' },
    { ay: 'November', tas: 'Citrine', renk: '#d97517', parlak: '#f4a22d' },
    { ay: 'December', tas: 'Blue Zircon', renk: '#4d8ec4', parlak: '#83cbed' },
  ];
  const AYLAR = TASLAR.map((t) => t.ay);
  const BURCLAR = [
    'Aries (Mar 21 – Apr 19)', 'Taurus (Apr 20 – May 20)', 'Gemini (May 21 – Jun 20)', 'Cancer (Jun 21 – Jul 22)',
    'Leo (Jul 23 – Aug 22)', 'Virgo (Aug 23 – Sep 22)', 'Libra (Sep 23 – Oct 22)', 'Scorpio (Oct 23 – Nov 21)',
    'Sagittarius (Nov 22 – Dec 21)', 'Capricorn (Dec 22 – Jan 19)', 'Aquarius (Jan 20 – Feb 18)', 'Pisces (Feb 19 – Mar 20)',
  ];
  // The store's birth flower chart (same as the necklace builder; the cut-out flower images follow this order)
  const CICEKLER = ['Snowdrop', 'Violet', 'Daffodil', 'Sweet Pea', 'Lily of the Valley', 'Rose', 'Larkspur', 'Poppy', 'Morning Glory', 'Marigold', 'Chrysanthemum', 'Poinsettia'];
  // the cut-out (openwork) birth flower jewelry is made from a different set of twelve designs (cicekSet "ajur")
  const CICEKLER_AJUR = ['Carnation', 'Violet', 'Daffodil', 'Daisy', 'Hawthorn', 'Rose', 'Lotus', 'Poppy', 'Aster', 'Marigold', 'Chrysanthemum', 'Holly'];
  // the sculpted gold flower ring (cicekSet "heykel") and the engraved flower signet ring (cicekSet "numarali") use the
  // twelve designs of their own workshop charts (shown in their product photos)
  const CICEKLER_HEYKEL = ['Snowdrop', 'Iris', 'Daffodil', 'Daisy', 'Hawthorn', 'Rose', 'Water Lily', 'Poppy', 'Morning Glory', 'Cosmos', 'Chrysanthemum', 'Holly'];
  const CICEKLER_NUMARALI = ['Snowdrop', 'Violet', 'Daffodil', 'Daisy', 'Lily of the Valley', 'Rose', 'Lotus', 'Poppy', 'Morning Glory', 'Cosmos', 'Chrysanthemum', 'Holly'];
  const CICEK_SETLERI = { ajur: CICEKLER_AJUR, heykel: CICEKLER_HEYKEL, numarali: CICEKLER_NUMARALI };
  const AY_KODU = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
  const tasDegeri = (t) => `${t.ay} – ${t.tas}`;
  // birth flower values: plain month (default), "January – Snowdrop" (with picture), "January – Snowdrop with Garnet" (stone set in the flower)
  const cicekDegeri = (alan, i, ad = CICEKLER) => (alan.tasli ? `${AYLAR[i]} – ${ad[i]} with ${TASLAR[i].tas}` : alan.gorsel ? `${AYLAR[i]} – ${ad[i]}` : AYLAR[i]);
  const aySirasi = (deger) => AYLAR.findIndex((a) => String(deger || '').startsWith(a));
  const metalBul = (malzeme) => (/rose/i.test(malzeme) ? 'rose' : /silver|white/i.test(malzeme) ? 'silver' : 'gold');
  const kac = (deger) => parseInt(String(deger || '').match(/\d+/)?.[0] || '0', 10);
  const kacis = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

  class KisiselAlanlar extends HTMLElement {
    connectedCallback() {
      if (this._hazir) return;
      this._hazir = true;
      const q = (s) => this.querySelector(s);
      this.formId = this.getAttribute('form-id');
      this.tanim = JSON.parse(q('[data-tanim]').textContent);
      this.secenekAdlari = JSON.parse(q('[data-secenek-adlari]').textContent);
      this.secili = JSON.parse(q('[data-secili]').textContent);
      this.ok = q('[data-ok]').innerHTML;
      this.kutu = q('[data-alanlar]');
      this.hata = q('[data-hata]');
      this.denetim = q('[data-denetim]');
      this.tanim.alanlar ||= [];
      this.cicekAdlari = CICEK_SETLERI[this.tanim.cicekSet] || CICEKLER;
      const gorsel = q('[data-cicek-gorsel]');
      this.cicekGorsel = gorsel ? JSON.parse(gorsel.textContent) : null;
      this.degerler = {};
      this.denendi = false;
      this.uid = Math.random().toString(36).slice(2, 8);

      this.ciz();

      if (this.kutu) {
        this.kutu.addEventListener('input', (e) => this.yakala(e.target));
        this.kutu.addEventListener('change', (e) => this.yakala(e.target));
      }
      // size chips (Length / Ring Size), drawn by the Liquid like the theme's variant picker
      this.querySelectorAll('[data-secim]').forEach((g) => g.addEventListener('change', () => { this.gecerlilik(); this.onizlemeGuncelle(); }));

      // The theme's form checks validity before adding to cart. "invalid" does not bubble, so it is caught here in the
      // capture phase for every field of the block: the browser's own bubble is suppressed (it doubled our message, in
      // the browser's language) and the customer is taken to the first empty field once.
      this.addEventListener('invalid', (e) => {
        e.preventDefault();
        if (this._uyarildi) return;
        this._uyarildi = true;
        setTimeout(() => { this._uyarildi = false; }, 300);
        this.denendi = true;
        this.gecerlilik();
        const bos = this.ilkBos();
        if (bos) {
          bos.focus({ preventScroll: true });
          setTimeout(() => bos.scrollIntoView({ block: 'center', behavior: 'smooth' }), 120);
        }
      }, true);

      // Repeating fields follow the theme's variant picker (e.g. "Number of Stones")
      this._varyant = (e) => {
        const kaynak = e.target instanceof HTMLFormElement ? e.target.getAttribute('id') : null;
        if (kaynak !== this.formId || !e.detail?.variant) return;
        this.secili = e.detail.variant.options || this.secili;
        this.ciz();
      };
      document.addEventListener('variant:change', this._varyant);

      // Birth flower guide (products with flower pictures)
      const cRehber = q('[data-cicek-rehber]');
      if (cRehber) {
        q('[data-cicek-rehber-ac]')?.addEventListener('click', () => { this.cicekRehberYaz(); cRehber.showModal(); });
        cRehber.addEventListener('click', (e) => { if (e.target === cRehber) cRehber.close(); });
        cRehber.querySelector('[data-kapat]').addEventListener('click', () => cRehber.close());
      }

      // Birthstone guide
      const rehber = q('[data-rehber]');
      if (rehber) {
        q('[data-rehber-liste]').innerHTML = TASLAR.map((t) => `<li class="kisisel__rehber-oge"><span class="kisisel__nokta" style="--tas:${t.renk};--tas-parlak:${t.parlak}"></span><span><strong>${t.ay}</strong><br>${t.tas}</span></li>`).join('');
        q('[data-rehber-ac]')?.addEventListener('click', () => rehber.showModal());
        rehber.addEventListener('click', (e) => { if (e.target === rehber) rehber.close(); });
        rehber.querySelector('[data-kapat]').addEventListener('click', () => rehber.close());
      }
    }

    // picture of a month's flower in the selected metal (Silver / White Gold -> silver, Rose -> rose, others gold)
    cicekResmi(i) {
      if (!this.cicekGorsel || i < 0) return '';
      const m = this.secenekAdlari.indexOf('Material');
      const metal = metalBul(m >= 0 ? this.secili[m] : '');
      return (this.cicekGorsel[metal] || this.cicekGorsel.gold || {})[AY_KODU[i]] || '';
    }

    cicekRehberYaz() {
      const liste = this.querySelector('[data-cicek-rehber-liste]');
      if (liste) liste.innerHTML = AYLAR.map((a, i) => `<li class="kisisel__rehber-oge"><img class="kisisel__cicek-resim" src="${kacis(this.cicekResmi(i))}" alt="" width="56" height="56" loading="lazy"><span><strong>${a}</strong><br>${this.cicekAdlari[i]}</span></li>`).join('');
    }

    disconnectedCallback() {
      document.removeEventListener('variant:change', this._varyant);
    }

    adet(alan) {
      if (alan.adetSecenek) {
        const i = this.secenekAdlari.indexOf(alan.adetSecenek);
        return Math.max(1, kac(this.secili[i]));
      }
      return Math.max(1, Number(alan.adet) || 1);
    }

    // longest text a field takes: from a count option ("Number of Letters": "5 Letters" -> 5), or fixed
    uzunluk(alan) {
      if (alan.uzunlukSecenek) {
        const i = this.secenekAdlari.indexOf(alan.uzunlukSecenek);
        return Math.max(1, kac(this.secili[i]));
      }
      return Number(alan.maks) || (alan.tur === 'harf' ? Number(alan.harf) || 1 : 0);
    }

    // property name: "Birthstone 1", "Birthstone 2" ... or just "Name" when the field appears once
    ad(alan, i, n) {
      if (alan.adlar && alan.adlar[i]) return alan.adlar[i];
      return n > 1 || alan.adetSecenek ? `${alan.etiket} ${i + 1}` : alan.etiket;
    }

    ciz() {
      if (!this.kutu) { this.gecerlilik(); return; }
      const satirlar = [];
      this.tanim.alanlar.forEach((alan, ai) => {
        const n = this.adet(alan);
        const grup = [];
        for (let i = 0; i < n; i++) grup.push(this.alanHtml(alan, ai, i, n));
        const baslik = alan.baslik ? `<p class="kisisel__grup-baslik">${kacis(alan.baslik)}</p>` : '';
        const ipucu = alan.ipucu ? `<p class="kisisel__ipucu">${kacis(alan.ipucu)}</p>` : '';
        satirlar.push(`<div class="kisisel__grup kisisel__grup--${alan.tur}">${baslik}<div class="kisisel__satirlar">${grup.join('')}</div>${ipucu}</div>`);
      });
      this.kutu.innerHTML = satirlar.join('');
      // file inputs cannot be refilled from script: their value stays only while the row lives
      this.onizlemeCiz();
      this.gecerlilik();
    }

    // ——— Live name preview (products with the 7-font "Font" choice, kisisel.onizleme): the name is written in the chosen
    // workshop font (assets/pz-font-f<N>.woff2, the same files as the Personalize builder) in the colour of the
    // material, and every font chip is set in its own font so the styles can be compared at a glance.
    onizlemeCiz() {
      if (!this.tanim.onizleme || !this.kutu) return;
      let k = this.querySelector('[data-onizleme]');
      if (!k) {
        k = document.createElement('div');
        k.className = 'kisisel__onizleme';
        k.setAttribute('data-onizleme', '');
        k.setAttribute('aria-live', 'polite');
        k.innerHTML = '<p class="kisisel__onizleme-baslik">Preview</p><div class="kisisel__onizleme-sahne"><span class="kisisel__onizleme-yazi" data-onizleme-yazi></span></div><p class="kisisel__onizleme-not" data-onizleme-not></p>';
        this.kutu.after(k);
        this.querySelectorAll('[data-secim="Font"] input').forEach((inp) => {
          const no = (inp.value.match(/\d+/) || [])[0];
          const yazi = this.querySelector(`label[for="${inp.id}"] span`);
          if (no && yazi) { yazi.style.fontFamily = `"PZ f${no}", serif`; yazi.classList.add('kisisel__font-adi'); }
        });
      }
      this.onizlemeGuncelle();
    }

    onizlemeGuncelle() {
      const k = this.querySelector('[data-onizleme]');
      if (!k) return;
      const grup = this.querySelector('[data-secim="Font"]');
      const secili = grup ? grup.querySelector('input:checked') : null;
      const ilk = grup ? grup.querySelector('input') : null;
      const fontDeger = (secili || ilk || {}).value || '';
      const no = (fontDeger.match(/\d+/) || [])[0];
      // what the customer has typed so far, one line per field in field order: letters, names, words and numbers
      // (2026-10-04: also rings, bracelets, anklets and cufflinks). Engravings that are not on the face (inside / back)
      // are left out. Before anything is typed, one example per required field: its own example, else "A", "2025",
      // "Your Name" (a field repeated for several names gives one example, as before).
      const alanlar = [...this.kutu.querySelectorAll('input[type="text"]')].filter((el) => !/inside|back/i.test(el.dataset.ad || ''));
      const yazilan = alanlar.map((el) => el.value.trim()).filter(Boolean);
      const ornekler = alanlar.filter((el) => el.hasAttribute('data-zorunlu') && /-0$/.test(el.dataset.anahtar || '')).map((el) => {
        const alan = this.tanim.alanlar[Number(el.dataset.anahtar.split('-')[0])] || {};
        if (alan.ornek) return alan.ornek;
        if (alan.tur === 'harf') return 'ABCD'.slice(0, Math.min(4, Math.max(1, this.uzunluk(alan))));
        return alan.tur === 'rakam' ? '2025' : 'Your Name';
      });
      const metin = yazilan.length ? yazilan : ornekler.length ? ornekler : ['Your Name'];
      const m = this.secenekAdlari.indexOf('Material');
      const malzeme = m >= 0 ? this.secili[m] || '' : '';
      k.classList.remove('is-gold', 'is-silver', 'is-rose');
      k.classList.add(`is-${metalBul(malzeme)}`);
      k.classList.toggle('is-ornek', !yazilan.length);
      const yazi = k.querySelector('[data-onizleme-yazi]');
      yazi.style.fontFamily = no ? `"PZ f${no}", cursive` : 'cursive';
      yazi.innerHTML = metin.map((t) => `<span>${kacis(t)}</span>`).join('');
      k.querySelector('[data-onizleme-not]').textContent = secili
        ? [secili.value, malzeme].filter(Boolean).join(' · ')
        : `Shown in ${fontDeger || 'the first font'} — choose your font above`;
      // the largest size (at most 54 px) at which the widest line still fits the box
      const sigdir = () => {
        const sahne = k.querySelector('.kisisel__onizleme-sahne');
        let px = 54;
        yazi.style.fontSize = `${px}px`;
        while (px > 18 && yazi.scrollWidth > sahne.clientWidth - 12) { px -= 2; yazi.style.fontSize = `${px}px`; }
      };
      sigdir();
      if (no && document.fonts && document.fonts.load) document.fonts.load(`48px "PZ f${no}"`, metin.join(' ')).then(sigdir).catch(() => {});
    }

    alanHtml(alan, ai, i, n) {
      const ad = this.ad(alan, i, n);
      const anahtar = `${ai}-${i}`;
      const id = `kisisel-${this.uid}-${anahtar}`;
      const deger = this.degerler[anahtar] ?? '';
      const zorunlu = alan.zorunlu !== false;
      const ortak = `id="${id}" name="properties[${kacis(ad)}]" form="${kacis(this.formId)}" data-anahtar="${anahtar}" data-ad="${kacis(ad)}"${zorunlu ? ' data-zorunlu' : ''}`;
      const etiket = `<label for="${id}" class="floating-label text-xs">${kacis(ad)}</label>`;

      if (alan.tur === 'tas' || alan.tur === 'cicek' || alan.tur === 'burc' || alan.tur === 'harftas' || alan.tur === 'liste') {
        let secenekler;
        // harftas: each position is either a letter or a birthstone (letters first, then the twelve stones)
        // liste: the product's own short list of choices (e.g. Boy / Girl)
        if (alan.tur === 'liste') secenekler = (alan.secenekler || []).map((v) => [v, v]);
        else if (alan.tur === 'harftas') secenekler = [...'ABCDEFGHIJKLMNOPQRSTUVWXYZ'].map((h) => [`Letter ${h}`, `Letter ${h}`]).concat(TASLAR.map((t) => [tasDegeri(t), `Birthstone: ${tasDegeri(t)}`]));
        else if (alan.tur === 'tas') secenekler = TASLAR.map((t) => [tasDegeri(t), tasDegeri(t)]);
        else if (alan.tur === 'cicek') secenekler = AYLAR.map((a, j) => [cicekDegeri(alan, j, this.cicekAdlari), cicekDegeri(alan, j, this.cicekAdlari)]);
        else secenekler = BURCLAR.map((b) => [b, b]);
        // a stone dot for birthstones and for flowers that carry their month's stone
        const tasGoster = alan.tur === 'tas' || alan.tur === 'harftas' || (alan.tur === 'cicek' && alan.tasli);
        const tas = tasGoster ? TASLAR[aySirasi(deger)] : null;
        const nokta = tasGoster ? `<span class="kisisel__nokta${tas ? '' : ' is-bos'}" aria-hidden="true" style="${tas ? `--tas:${tas.renk};--tas-parlak:${tas.parlak}` : ''}"></span>` : '';
        // the month's flower, small, next to the choice
        if (alan.tur === 'cicek' && alan.gorsel) {
          const resim = deger ? this.cicekResmi(aySirasi(deger)) : '';
          return `<div class="kisisel__cicek-satir"><span class="kisisel__cicek-kutu${resim ? '' : ' is-bos'}" aria-hidden="true">${resim ? `<img class="kisisel__cicek-resim" src="${kacis(resim)}" alt="" width="56" height="56">` : ''}</span>
            <div class="form-control kisisel__secim"><select class="select" ${ortak}${zorunlu ? ' required' : ''}>
              <option value=""${deger ? '' : ' selected'} disabled>${kacis(ad)}</option>
              ${secenekler.map(([v, y]) => `<option value="${kacis(v)}"${v === deger ? ' selected' : ''}>${kacis(y)}</option>`).join('')}
            </select>${this.ok}${etiket}</div></div>`;
        }
        return `<div class="form-control kisisel__secim${tasGoster ? ' kisisel__secim--tas' : ''}">${nokta}
          <select class="select" ${ortak}${zorunlu ? ' required' : ''}>
            <option value=""${deger ? '' : ' selected'} disabled>${kacis(ad)}</option>
            ${secenekler.map(([v, y]) => `<option value="${kacis(v)}"${v === deger ? ' selected' : ''}>${kacis(y)}</option>`).join('')}
          </select>${this.ok}${etiket}</div>`;
      }
      if (alan.tur === 'dosya') {
        return `<div class="kisisel__dosya"><label for="${id}" class="kisisel__dosya-etiket">${kacis(ad)}</label>
          <input type="file" accept="${kacis(alan.kabul || 'image/*')}" class="kisisel__dosya-girdi" ${ortak}${zorunlu ? ' required' : ''}></div>`;
      }
      // metin / harf / rakam
      const maks = this.uzunluk(alan);
      const ekler = [];
      if (maks) ekler.push(`maxlength="${maks}"`);
      if (alan.tur === 'harf') ekler.push('autocapitalize="characters"', 'autocomplete="off"', 'spellcheck="false"');
      if (alan.tur === 'rakam') ekler.push('inputmode="numeric"', 'autocomplete="off"');
      const kisa = maks ? String(deger).slice(0, maks) : String(deger);
      if (kisa !== deger) this.degerler[anahtar] = kisa;
      // letters that are separate pieces: the field takes exactly as many letters as the chosen count
      const yer = alan.tam && maks > 1 ? `${ad} – ${maks} letters` : alan.ornek ? `${ad} (e.g. ${alan.ornek})` : ad;
      const sayac = maks > 1 ? `<span class="kisisel__sayac" aria-hidden="true">${kisa.length}/${maks}</span>` : '';
      return `<div class="form-control kisisel__metin${alan.tur === 'harf' ? ' kisisel__metin--harf' : ''}">
        <input type="text" class="input" placeholder="${kacis(yer)}" value="${kacis(kisa)}" ${ortak} ${ekler.join(' ')}${zorunlu ? ' required' : ''}>
        <label for="${id}" class="floating-label text-xs">${kacis(ad)}</label>${sayac}</div>`;
    }

    yakala(el) {
      const anahtar = el.dataset?.anahtar;
      if (anahtar == null) return;
      const ai = Number(anahtar.split('-')[0]);
      const alan = this.tanim.alanlar[ai];
      if (el.type === 'file') {
        this.degerler[anahtar] = el.files && el.files.length ? el.files[0].name : '';
      } else {
        let v = el.value;
        if (alan.tur === 'harf') { v = v.toUpperCase().replace(/[^A-Z&]/g, ''); if (v !== el.value) el.value = v; }
        if (alan.tur === 'rakam') { v = v.replace(/[^0-9]/g, ''); if (v !== el.value) el.value = v; }
        this.degerler[anahtar] = v;
        const sayac = el.parentElement.querySelector('.kisisel__sayac');
        if (sayac) sayac.textContent = `${v.length}/${el.maxLength}`;
      }
      if (alan.tur === 'tas' || alan.tur === 'harftas' || (alan.tur === 'cicek' && alan.tasli)) {
        const tas = TASLAR[aySirasi(el.value)];
        const nokta = el.parentElement.querySelector('.kisisel__nokta');
        if (nokta && !tas) nokta.classList.add('is-bos');                // harftas: a letter has no stone
        if (nokta && tas) { nokta.classList.remove('is-bos'); nokta.style.setProperty('--tas', tas.renk); nokta.style.setProperty('--tas-parlak', tas.parlak); }
      }
      if (alan.tur === 'cicek' && alan.gorsel) {
        const kutu = el.closest('.kisisel__cicek-satir')?.querySelector('.kisisel__cicek-kutu');
        const resim = this.cicekResmi(aySirasi(el.value));
        if (kutu && resim) { kutu.classList.remove('is-bos'); kutu.innerHTML = `<img class="kisisel__cicek-resim" src="${kacis(resim)}" alt="" width="56" height="56">`; }
      }
      this.onizlemeGuncelle();
      this.gecerlilik();
    }

    eksik(el) {
      if (!el.hasAttribute('data-zorunlu')) return false;
      const v = el.type === 'file' ? (el.files && el.files.length ? 'x' : '') : String(el.value || '').trim();
      if (!v) return true;
      const ai = Number(el.dataset.anahtar.split('-')[0]);
      const alan = this.tanim.alanlar[ai];
      // initials: exactly as many letters as the design takes
      if (alan.tam && v.length !== this.uzunluk(alan)) return true;
      return false;
    }

    // a size group without a default (ring size) must be picked by the customer
    secimEksik(g) {
      return g.hasAttribute('data-zorunlu') && !g.querySelector('input:checked');
    }

    ilkBos() {
      const grup = Array.from(this.querySelectorAll('[data-secim]')).find((g) => this.secimEksik(g));
      if (grup) return grup.querySelector('input');
      if (!this.kutu) return null;
      return Array.from(this.kutu.querySelectorAll('[data-anahtar]')).find((el) => this.eksik(el)) || null;
    }

    gecerlilik() {
      const bos = this.ilkBos();
      let mesaj = '';
      if (bos && bos.closest('[data-secim]')) {
        mesaj = `Please choose your ${bos.closest('[data-secim]').dataset.secim}.`;
      } else if (bos) {
        const ai = Number(bos.dataset.anahtar.split('-')[0]);
        const alan = this.tanim.alanlar[ai];
        const ad = bos.dataset.ad;
        if (alan.tur === 'tas' || alan.tur === 'cicek' || alan.tur === 'burc' || alan.tur === 'harftas' || alan.tur === 'liste') mesaj = `Please choose ${ad}.`;
        else if (alan.tur === 'dosya') mesaj = `Please add ${ad}.`;
        else if (alan.tam && String(bos.value).trim()) mesaj = this.uzunluk(alan) > 1 ? `Please enter ${this.uzunluk(alan)} letters for ${ad}.` : `Please enter ${ad}.`;
        else mesaj = `Please enter ${ad}.`;
      }
      this.denetim.setCustomValidity(mesaj);
      this.querySelectorAll('[data-secim]').forEach((g) => g.classList.toggle('is-eksik', this.denendi && this.secimEksik(g)));
      this.kutu?.querySelectorAll('[data-anahtar]').forEach((el) => el.closest('.form-control, .kisisel__dosya')?.classList.toggle('is-eksik', this.denendi && this.eksik(el)));
      this.hata.hidden = !(this.denendi && mesaj);
      this.hata.textContent = this.denendi ? mesaj : '';
    }
  }

  window.customElements.define('kisisel-alanlar', KisiselAlanlar);
}
